export const TrendChartConfig = {
    responsive: true,
    elements: {
        line: {
            tension: 0,
            fill: false,
            borderColor: 'green',
            pointHoverBackgroundColor: 'blue'
        }
    },
    scales: {
        yAxis:{
            title: {
                display: true,
                text: 'Response Time in ms',
              },
            id: 'y-axis-1',
            type: 'linear',
            position: 'left',
        },
        xAxis: {
            title: {
                display: true,
                text:  'Date of execution'
              },
            interval: 5,
            ticks: {
                maxRotation: 90,
                minRotation: 45,
                maxTicksLimit: 20.6,
            }
        }
    },
};
